import { rem, token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const sliderStyles = [
  css`
    :host {
      display: flex;
      flex-direction: column;
    }

    .slider {
      accent-color: ${token('slider-accent-default')};
      color: ${token('slider-foreground-default')};
    }

    :where(label) {
      font-size: ${rem(16)};
      font-weight: bold;
    }
  `,
];
